module.exports = __webpack_public_path__ + "img/Richang_Hong@2x.c7e255cd.png";